import React from "react";
import { connect } from "react-redux";
import fetchBlogPost from "../../modules/blog/fetchBlogPost";
import Loader from "../../components/Loader";
import Post from "./index";

class PostContainer extends React.Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    if (!this.props.posts[id]) {
      this.props.fetchBlogPost(id);
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    if (this.props.loading) {
      return (
        <div style={{ paddingTop: "100px" }}>
          <Loader />
        </div>
      );
    }
    const currentPost =
      this.props.posts[this.props.match.params.id] || this.props.currentPost;
    return <Post {...currentPost} language={this.props.language} />;
  }
}

function mapStateToProps(state) {
  return {
    id: state.blogPosts.id,
    posts: state.blogPosts.publicPosts,
    currentPost: state.blogPosts.currentPost,
    loading: state.blogPosts.loading,
    language: state.preference.language
  };
}

const mapActionsToProps = {
  fetchBlogPost
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(PostContainer);



// WEBPACK FOOTER //
// ./src/pages/Post/container.js